<template>
    <main class="login-form1">
        <b-container class="cotainer">
            <b-row align-h="center">
                <b-col md="8">
                    <b-card title="Εγγραφή νέου χρήστη Συστήματος">
                        <b-card-text>
                          <br/>
                          <b-alert show variant="info">
                            Εάν ο Στρατιωτικός μου Αριθμός εμφανίζεται με μορφή 15310101014 ή με μορφή 153/101010/14 ή με μορφή 153 101010 14 θα πρέπει να επιλέξω στο πρώτο πεδίο το 153, στο δεύτερο πεδίο να συμπληρώσω το 101010 και στο τρίτο πεδίο να επιλέξω το 2014. Ο Αριθμός Στρατιωτικού Μητρώου συμπληρώνεται πάντα με 6 αριθμητικά ψηφία. Π.χ το Σ.Α 153/111/14 συμπληρώνεται με το δεύτερο πεδίο να περιλαμβάνει τα μηδενικά ως εξής: πρώτο πεδίο 153, δεύτερο πεδίο 000111 και τρίτο πεδίο 2014.
                          </b-alert>
                            <b-form>
                                <b-row cols-md="12" align-h="center">
                                    <b-card bg-variant="light" header="* Στρατολογικός Αριθμός (Σ.Α.)" style="width: 95%;" class="text-center">
                                        <b-card-text>
                                            <b-row cols-sm="12">
                                                <b-col sm="3">
                                                    * Α.Σ.Υ
                                                    <b-form-select v-model="asmOptions1Selected" :options="asmOptions1">
                                                    </b-form-select>
                                                </b-col>
                                                <b-col sm="6">
                                                  * Α.Σ.Μ
                                                  <letter-input v-model="midAsm"   :digits="6"></letter-input>
                                                </b-col>
                                                <b-col sm="3">
                                                  * Κλάση
                                                    <b-form-select v-model="asmOptions2Selected" :options="asmOptions2" style="text-align: right;">
                                                    </b-form-select>
                                                </b-col>
                                            </b-row>
                                            <br>
                                            <b-row>
                                                <b-col sm="12">
                                                <Message :disable-close="true" v-if="msgVisibleSa" v-bind:msgClass="msgClassSa"
                                                         v-bind:message="messageSa"></Message>
                                                </b-col>
                                            </b-row>
                                        </b-card-text>
                                    </b-card>
                                </b-row>
                                <br/>

                                <b-row cols-md="12" align-h="center">
                                    <b-card bg-variant="light" header="* Μητρώο Αρρένων" style="width: 95%;" class="text-center">
                                        <b-card-text>
                                            <b-row cols-sm="12">
                                                <b-col sm="4">
                                                    * Νομαρχία
                                                </b-col>
                                                <b-col sm="4">
                                                    * Δήμος
                                                </b-col>
                                                <b-col sm="4">
                                                    * Τοπικό Διαμέρισμα
                                                </b-col>
                                            </b-row>
                                            <b-row cols-sm="12">
                                                <b-col sm="4">
                                                    <b-form-select v-model="nomarxia" :options="nomarxies" @change="getDhmous($event)">
                                                    </b-form-select>
                                                </b-col>
                                                <b-col sm="4">
                                                    <b-form-select v-model="dhmos" :options="dhmoi" @change="getDhmotikaDiamerismata($event)">
                                                    </b-form-select>
                                                </b-col>
                                                <b-col sm="4">
                                                    <b-form-select v-model="topikoDiamerisma" :options="topikaDiamerismata">
                                                    </b-form-select>
                                                </b-col>
                                            </b-row>
                                            <br>
                                            <b-row>
                                                <b-col sm="12">
                                                    <Message :disable-close="true" v-if="msgVisibleMhtr"  variant="danger" style="color: #721c24; background-color: #f8d7da;  border-color: #f5c6cb;border-style: solid; border-radius: 3px;"
                                                             v-bind:message="messageMhtr"></Message>
                                                </b-col>
                                            </b-row>
                                        </b-card-text>
                                    </b-card>
                                </b-row>
                                <br/>
                                <b-row cols-md="12" align-h="center">
                                    <b-col md="12">
                                    <b-form-group label-cols-md="4" label-align-md="right" label-for="afm"
                                                  label="* ΑΦΜ"
                                                  content-cols-md="6">
                                        <b-form-input id="afm" :readonly="true"
                                                      v-model="userAFM"/>
                                    </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row cols-md="12" align-h="center">
                                    <b-col md="12">
                                        <b-form-group label-cols-md="4" label-align-md="right" label-for="efsa"
                                                      label="* E-Mail Address"
                                                      content-cols-md="6"
                                                      :invalid-feedback="emailValidation.msg">
                                            <b-form-input id="efsa" :state="!showError ? null : emailValidation.state"
                                                          v-model="identification.email"/>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row cols-md="12" align-h="center">
                                    <b-col md="12">
                                        <b-form-group label-cols-md="4" label-align-md="right" label-for="mobileThl"
                                                      label="* Κινητό Τηλέφωνο"
                                                      content-cols-md="6"
                                                      :state="!showError ? null : kinhtoValidation"
                                                      :invalid-feedback="kinhtoValidation.msg">
                                            <b-form-input id="mobileThl" :state="!showError ? null : kinhtoValidation.state"
                                                          v-model="identification.mobileThl"/>
                                        </b-form-group>
                                        <b-tooltip target="mobileThl" triggers="hover">
                                            <p>Παρακαλούμε εισάγετε το κινητό σας τηλέφωνο</p>
                                        </b-tooltip>
                                    </b-col>
                                </b-row>
                                <b-row cols-md="12" align-h="center">
                                    <b-col md="12">
                                        <b-form-group label-cols-md="4" label-align-md="right" label-for="statheroThl"
                                                      label="Σταθερό Τηλέφωνο"
                                                      content-cols-md="6"
                                                      :invalid-feedback="statheroValidation.msg">
                                            <b-form-input id="statheroThl" :state="!showError ? null : statheroValidation.state"
                                                          v-model="identification.statheroThl"/>
                                        </b-form-group>
                                        <b-tooltip target="statheroThl" triggers="hover">
                                            <p>Παρακαλούμε εισάγετε το σταθερό σας τηλέφωνο.</p>
                                        </b-tooltip>
                                    </b-col>
                                </b-row>

                                <div class="col-md-12">
                                    <div id="g-recaptcha" style="display: inline-block;"></div>
                                    <div id="g-recaptcha-error"></div>

                                    <router-link class="nav-link" to="/data-privacy" style="display: inline-block;"><u>Πολιτική Απορρήτου</u>
                                    </router-link>
                                    <br>
                                    <button type="submit" v-on:click.prevent="submitForValidation"
                                            class="btn btn-primary" style="margin:5px;">
                                        Επικύρωση
                                    </button>
                                    <button type="submit" v-on:click="logout" class="btn btn-danger"
                                            style="margin:5px;">
                                        Ακύρωση
                                    </button>
                                </div>

                                <br>
                                <Message  v-if="msgVisible" v-bind:msgClass="msgClass"
                                         v-bind:message="message"></Message>
                            </b-form>
                            <b-col md="12">
                                <div class="form-group row sm_cl">
                                    Σε περίπτωση αδυναμίας εγγραφής σας παρακαλούμε όπως αποστείλετε τον Σ.Α., το ΑΦΜ
                                    σας και ένα τηλέφωνο επικοινωνίας στην διεύθυνση des-mo@army.gr
                                    <br>Θα σας απαντήσουμε στο αίτημα σας προσεχώς.
                                </div>
                            </b-col>
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </main>
</template>

<script>
import Message from '../components/Message.vue'
import {debounce} from 'lodash';
import VueCookies from "vue-cookies";
import {Structs} from "@/structs";
import LetterInput from "@/components/LetterInput";
export default {
    name: "Validate",
    components: {
      LetterInput,
        Message,
    },
    data() {
        return {
            maSearchInfo: Structs.SearchInfo(),
            identification: {
                efsa: '',
                email: '',
                mhtrwoArrenwn: '',
                mobileThl: '',
                statheroThl: ''
            }, //Structs.SimpleUserIdentification(),
            message: '',
            msgVisible: false,
            msgClass: '',
            messageSa: '',
            msgVisibleSa: false,
            msgClassSa: '',
            msgVisibleMhtr: false,
            messageMhtr: '',
            msgClassMhtr: '',
            showError: false,
            asmOptions1Selected: '',
            nomarxia: '',
            dhmos: '',
            topikoDiamerisma: '',
            nomarxies: [],
            dhmoi: [],
            topikaDiamerismata: [],
            asmOptions2Selected: '',
            midAsm: '',
            asmOptions1: [],
            asmOptions2: [],
        }
    },

    computed: {
        userRole() {
            return this.$store.getters.userRole
        },
        userAFM() {
            return this.$store.getters.getUserAfm;
        },
        saValidation() {
            return {
                state: /^\d{11}$/.test( (this.asmOptions1Selected + '' + this.midAsm + '' + this.asmOptions2Selected.slice(2)).split(' ').join('')),
                msg: "Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου."
            }
        },
        afmValidation() {
            return {
                state: this.$validator.onlyNumbers(this.userAFM),
                msg: "Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου."
            }
        },
        emailValidation() {
            return {
                state: this.$validator.validateEmail(this.identification.email),
                msg: "Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου."
            }
        },
        statheroValidation() {
            if (this.identification.statheroThl == null || this.identification.statheroThl === '') {
                return {
                    state: null
                }
            } else {
                return {
                    state: /^\d{10,14}$|^\d{0}$/.test(this.identification.statheroThl),
                    msg: 'Παρακαλώ εισάγεται τα ψηφία του σταθερού σας τηλεφώνου. Σε περίπτωση που δεν έχετε σταθερό αφήστε το πεδίο κενό.'
                }
            }
        },
        kinhtoValidation() {
            return {
                state: /^\d{10,14}$/.test(this.identification.mobileThl),
                msg: 'Απαγορεύονται οι ειδικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου.'
            }
        },
        mhtrwoArrenwnValidation() {
            if(!(this.nomarxia != '' && this.dhmos != '' && this.topikoDiamerisma != '')) {
                this.messageMhtr = 'Παρακαλώ συμπληρώστε και τα 3 πεδία του Μητρώου Αρρένων.'
                this.msgVisibleMhtr = true;
            }
            return {
                state: this.nomarxia != '' && this.dhmos != '' && this.topikoDiamerisma != '' ,
                msg: 'Παρακαλώ εισάγετε το μητρώο αρρένων σας.'
            }
        }
    },
    mounted() {
      this.getUserInfo().then(() => {
        if (this.userRole !== 'ROLE_UNREGISTERED') {
          this.$router.push('/');
          return;
        }

        this.getUserTaxInfo().then(() => {
                this.$nextTick(grecaptcha.ready(this.renderCaptcha));
                this.getNomarxies()
                this.getAsmAsy()
                this.getAsmKlasi()
            })
            .catch(() => {
                this.errorMessageInit('Προέκυψε σφάλμα κατά την ανάκτηση του Αριθμού Φορολογικού Μητρώου')
            })
        }).catch(() => {
          this.errorMessageInit('Προέκυψε σφάλμα κατά την ανάκτηση των στοιχείων του χρήστη')
        })
    },
    methods: {
        getUserTaxInfo() {
          return this.$store.dispatch('getUserTaxInfo')
        },
        getUserInfo() {
            return this.$store.dispatch('getUserInfo')
        },
        getNomarxies() {
            this.$http.get('/search/mhtr-arren/nomarxies').then((res) => {
                this.nomarxies = res.data.responseData;
            }).catch((e) => {
                console.error('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής')
                this.errorMessageInit('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής. Παρακαλούμε προσπαθήστε αργότερα.')
            })
        },
        getAsmAsy() {
            this.$http.get('/search/asm/asy').then((res) => {
                this.asmOptions1 = res.data.responseData;
            }).catch((e) => {
                console.error('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής')
                this.errorMessageInit('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής. Παρακαλούμε προσπαθήστε αργότερα.')
            })
        },
        getAsmKlasi() {
            this.$http.get('/search/asm/klasi').then((res) => {
                this.asmOptions2 = res.data.responseData;
            }).catch((e) => {
                console.error('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής')
                this.errorMessageInit('Σφάλμα κατά την ανάκτηση πληροφοριών της φόρμας υποβολής. Παρακαλούμε προσπαθήστε αργότερα.')
            })
        },
        getDhmous(nomarxia) {

            this.$store.dispatch('loading');

            this.topikaDiamerismata = [];
            this.topikoDiamerisma = '';
            this.dhmoi = [];
            this.dhmos = '';

            this.$http.get('/search/mhtr-arren/nomarxia/' + nomarxia + '/dhmoi').then(res => {
                this.dhmoi = res.data.responseData;
            }).catch(() => {})
            .finally(() => {
                this.$store.dispatch("stop_loading");
            });
        },
        getDhmotikaDiamerismata(dhmos) {
            this.$store.dispatch('loading');
            this.topikoDiamerisma = [];
            this.$http.get(`/search/mhtr-arren/nomarxia/${this.nomarxia}/dhmos/${dhmos}/topika-diamerismata`).then(res => {
                this.topikaDiamerismata = res.data.responseData;
            }).catch(() => {})
            .finally(() => {
                this.$store.dispatch("stop_loading");
            });
        },
        midAsmAutocompleteZeros() {

            if(/^\d+$/.test(this.midAsm)) {

                let str = '';

                for (var i = 0; i < 6 - this.midAsm.length; i++) {

                    str += '0';
                }

                str += this.midAsm;

                this.midAsm = str;
                this.$refs.midAsmInput.classList.remove('invalidMidAsm');

                this.saValidation();
            } else {
                this.$refs.midAsmInput.classList.add('invalidMidAsm');
            }
        },

        clearMsgBox() {
            this.message = '';
            this.msgVisible = false;
            this.msgClass = '';
        },

        submitForValidation() {
            if (!this.isFormValid()) {

                if(!this.saValidation.state) {
                    this.messageSa = "Πρέπει να συμπληρώσετε σωστά και τα 3 πεδία του ΣΑ. Ο Α.Σ.Μ αποτελείται από ακριβώς 6 ψηφία. Αν έχετε λιγότερα συμπληρώστε στην αρχή με μηδέν (0)";
                    this.msgClassSa = 'danger';
                    this.msgVisibleSa = true;
                }else{
                  this.msgVisibleSa = false;
                }
                return;
            }

            this.identification.mhtrwoArrenwn = this.nomarxia.trim() + ', ' + this.dhmos.trim() + ', ' + this.topikoDiamerisma.trim();
            this.identification.efsa = (this.asmOptions1Selected + '' + this.midAsm + '' + this.asmOptions2Selected.slice(2));
            let response = grecaptcha.getResponse();

            if (response.length == 0) {
                document.getElementById('g-recaptcha-error').innerHTML = '' +
                    '<span style="color:red;">Η επίλυση του captcha είναι απαραίτητη.</span>';
                return;
            }
            this.$store.dispatch("loading")

            this.$http.post('/users/signup', this.identification).then(res => {
                this.$store.commit("setUserAFM", "");
                if (VueCookies.get('token')) {
                    this.$store.commit("set_token", VueCookies.get('token'))
                }
                this.$store.dispatch("stop_loading")
                // this.$router.push({path: '/home'})
                window.open(process.env.VUE_APP_API_URL + 'api/auth/login', "_self");
            }).catch((e) => {
                var resp = e.response;
                this.message = (resp.data.errorMessage) ? resp.data.errorMessage : resp.statusText;
                if (this.message === "") {
                    this.message = "Υπήρξε κάποιο πρόβλημα με την αίτηση σας!"
                }
                this.msgClass = 'danger';
                this.msgVisible = true;
                this.$store.dispatch('stop_loading');
            })
        },

        logout() {
            this.$store.dispatch('logoutUser')
        },

        searchMa: debounce(function (newQuery) {
            // if (newQuery.length < 4) return
            this.maSearchInfo.isLoading = true
            this.$http.get(`/search/mhtr-arren?keyword=${newQuery}`)
                .then((res) => {
                    this.maSearchInfo.isLoading = false
                    this.maSearchInfo.list = res.data.responseData
                })
        }, 500),

        isFormValid() {
            if ((this.saValidation.state && this.afmValidation.state
                && this.emailValidation.state && this.mhtrwoArrenwnValidation.state
                && this.kinhtoValidation.state && this.statheroValidation.state) === false) {
                this.showError = true;
                this.msgClass = 'danger';
                this.message = 'Θα πρέπει να συμπληρώσετε τα απαραίτητα πεδία της φόρμας.';
                this.msgVisible = true;
                return false;
            } else {
                this.clearMsgBox();
                return true;
            }
        },

        verifyCaptcha: function () {
            document.getElementById('g-recaptcha-error').innerHTML = '';
        },

        renderCaptcha: function () {
            // eslint-disable-next-line no-undef
            grecaptcha.render('g-recaptcha', {
                'sitekey': '6Lep3bgUAAAAAIWxoYkjCBlAzFwLaZFgX1AHbZzc',
                'callback': this.verifyCaptcha(),
                'theme': 'light'
            });
        },

        errorMessageInit(message) {
            this.msgClass = 'danger';
            this.msgVisible = true;
            this.message = message;
        }
    }
}
</script>

<style scoped>

.sm_cl {
    justify-content: center;
    text-align: center;
    font-size: 13px;
    color: #0072C6;
}
/* CSS animation */

@-webkit-keyframes fadeIn {
    0% {
        opacity: 0;
        transform: scale(0.6);
    }

    100% {
        opacity: 100%;
        transform: scale(1);
    }
}

.invalidMidAsm{
    border-color: #c10000!important;
    border-style: solid;
    border-radius: 3px;
}

.invalidMhtr{
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
    border-style: solid;
    border-radius: 3px;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 100%;
    }
}
</style>
